<section class="card">

    <div class="card-header">
        <span class="cat__core__title">
            <strong id="pageTitle">Register of Beneficial Owners holding significant beneficial interest</strong>
        </span>
        <span style="float: right">
            <!-- <a routerLink="/ben3list"> -->
                <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
        <span style="float:right">
            <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button"  *ngIf="!restrictTabFlag">
                <span>
                  <i class="fa fa-save"></i>&nbsp;Generate Output </span>
              </button>
      </span>
    </div>

                
                    <form [formGroup]='boForm' (document:click)="a.close();b.close();c.close();d.close();e.close()">
                            <div class="modal-body">
                        <div class="row ">
                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Name of the Beneficial Owner</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['name']" class="form-control">

                                    <div *ngIf="boForm.controls['name'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Name of the Beneficial Owner is invalid
                                    </div>
                                    <div *ngIf="boForm.controls['name'].hasError('required') && boForm.controls['name'].touched"
                                        class="form-control-error-custom">
                                        Name of the Beneficial Owner is required
                                    </div>
                                </div>
                            </div>


                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Address</label>
                                <div class="form-group">
                                    <textarea [formControl]="boForm.controls['address']"
                                        class="form-control"></textarea>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">E-mail id <span _ngcontent-c2=""
                                        style="color: red;">*</span></label>
                                <div class="form-group">
                                    <input type="email" [formControl]="boForm.controls['email']" class="form-control">

                                    <div *ngIf="boForm.get('email').hasError('required') && boForm.get('email').touched"
                                        class="form-control-error-custom">
                                        E-mail id is required
                                    </div>
                                    <div *ngIf="boForm.get('email').hasError('email') && !boForm.get('email').hasError('required') && boForm.get('email').touched"
                                        class="form-control-error-custom">
                                        E-mail id is invalid
                                    </div>


                                </div>


                            </div>
                        </div>
                        <div class="row">

                            <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Date of Birth</label>
                                <div class="input-group" (click)="$event.stopPropagation()">
                                    <input class="form-control" [(ngModel)]="dateOfdobModel" name="dob"
                                        [formControl]="boForm.controls['dob']" style="padding:6px;z-index: 0;"
                                        placeholder="dd-mm-yyyy" ngbDatepicker #a="ngbDatepicker"
                                        (click)="a.toggle()">
                                    <button class="input-group-addon"
                                        (click)="a.toggle()" type="button">
                                        <span class="fa fa-calendar"
                                            style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                    </button>
                                </div>
                            </div>


                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Father’s/ Mother’s/ Spouse’s name</label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['fathername']" class="form-control">
                                    <div *ngIf="boForm.controls['fathername'].hasError('pattern') && !boForm.controls['fathername'].hasError('required')"
                                        class="form-control-error-custom">
                                        Father’s/ Mother’s/ Spouse’s name is invalid
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Occupation</label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['occupation']" class="form-control">
                                    <div *ngIf="boForm.controls['occupation'].hasError('pattern') && !boForm.controls['occupation'].hasError('required')"
                                        class="form-control-error-custom">
                                        Occupation is invalid
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Nationality</label>
                                <!-- <div class="form-group">
                                    <input [formControl]="boForm.controls['nationality']" class="form-control">
                                    <div *ngIf="boForm.controls['nationality'].hasError('pattern') && !boForm.controls['nationality'].hasError('required')"
                                        class="form-control-error-custom">
                                        Nationality is invalid
                                    </div>
                                </div> -->
                                <select class="form-control" [formControl]="boForm.controls['nationality']"
                                style="padding:6px;">
                                <option value="">Select</option>
                                <option *ngFor="let country of countryList"
                                  [selected]="country.Country==boForm.controls['nationality'].value"
                                  [value]="country.Country">
                                  {{country.Country}}
                                </option>
                              </select>

                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">PAN /UIN
                                </label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['pan']"
                                        pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$"
                                        class="form-control upperCase">
                                    <div *ngIf="boForm.controls['pan'].hasError('pattern') && !boForm.controls['pan'].hasError('required')"
                                        class="form-control-error-custom">
                                        PAN /UIN is invalid
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">CIN (in case of company)
                                </label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['cin']" class="form-control">
                                    <div *ngIf="(boForm.controls['cin'].hasError('maxlength') || boForm.controls['cin'].hasError('minlength')) &&  boForm.controls['cin'].touched"
                                        class="form-control-error-custom">
                                        CIN should be 21 character
                                    </div>
                                    <div *ngIf="boForm.controls['cin'].hasError('pattern') && !boForm.controls['cin'].hasError('required')"
                                        class="form-control-error-custom">
                                        CIN is invalid
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Passport No. (in case of foreign national)
                                </label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['passport']" class="form-control">
                                    <div *ngIf="boForm.controls['passport'].hasError('pattern') && !boForm.controls['passport'].hasError('required')"
                                        class="form-control-error-custom">
                                        Passport No. is invalid
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Status
                                </label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['status']" class="form-control">
                                </div>
                            </div>

                            <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Date of declaration under section 90</label>
                                <div class="input-group" (click)="$event.stopPropagation()">
                                    <input class="form-control" [(ngModel)]="dateOfddu90Model"
                                        name="dateofdeclarationundersection90"
                                        [formControl]="boForm.controls['dateofdeclarationundersection90']"
                                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                                        #b="ngbDatepicker"
                                        (click)="b.toggle()
                                        ">
                                    <button class="input-group-addon"
                                        (click)="b.toggle()
                                        " type="button">
                                        <span class="fa fa-calendar"
                                            style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div class="row">

                            <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Date of cessation</label>
                                <div class="input-group" (click)="$event.stopPropagation()">
                                    <input class="form-control" [(ngModel)]="dateOfCessationModel"
                                        name="dateOfCessation" [formControl]="boForm.controls['dateOfCessation']"
                                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                                        #c="ngbDatepicker"
                                        (click)="c.toggle()">
                                    <button class="input-group-addon"
                                        (click)="c.toggle()" type="button">
                                        <span class="fa fa-calendar"
                                            style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Date of entry in Register</label>
                                <div class="input-group" (click)="$event.stopPropagation()">
                                    <input class="form-control" [(ngModel)]="dateOfEntryModel" name="dateOfEntry"
                                        [formControl]="boForm.controls['dateOfEntry']" style="padding:6px;z-index: 0;"
                                        placeholder="dd-mm-yyyy" ngbDatepicker #d="ngbDatepicker"
                                        (click)="d.toggle()">
                                    <button class="input-group-addon"
                                        (click)="d.toggle()" type="button">
                                        <span class="fa fa-calendar"
                                            style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Date of filing of BEN-2 (SRN wise)</label>
                                <div class="input-group" (click)="$event.stopPropagation()">
                                    <input class="form-control" [(ngModel)]="dateOfBEN2Model" name="dateOfBEN2"
                                        [formControl]="boForm.controls['dateOfBEN2']" style="padding:6px;z-index: 0;"
                                        placeholder="dd-mm-yyyy" ngbDatepicker #e="ngbDatepicker"
                                        (click)="e.toggle()">
                                    <button class="input-group-addon"
                                        (click)="e.toggle()" type="button">
                                        <span class="fa fa-calendar"
                                            style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Amount of guarantee, if any </label>
                                <div class="form-group">
                                    <input [formControl]="boForm.controls['amount']" (keydown)="onlyNumber($event)"
                                        class="form-control">
                                    <div *ngIf="boForm.controls['amount'].hasError('pattern') && !boForm.controls['amount'].hasError('required')"
                                        class="form-control-error-custom">
                                        Amount of guarantee is invalid
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Any other interest, if any
                                </label>
                                <div class="form-group">
                                    <textarea [formControl]="boForm.controls['otherInterest']"
                                        class="form-control"></textarea>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12">
                                <label class="form-control-label">Instructions, if any, given by the member
                                </label>
                                <div class="form-group">
                                    <textarea [formControl]="boForm.controls['instructionIf']"
                                        class="form-control"></textarea>
                                </div>
                            </div>

                        </div>
                            </div>
                            <div class="card-footer" align="right"> 
                           
  
                               
                                    <button class="btn btn-sm btn-primary" (click)="showFormEntry()" type="button" *ngIf="restrictTabFlag"
                                        [disabled]="!boForm.valid || disabledOnclick">
                                        <span>
                                            <i class="fa fa-save"></i>&nbsp;Save</span>
                                    </button>
                                
                               
                               
                               
                               
                               
                                    <button class="btn btn-sm btn-primary" (click)="updatebeneficialOwner()"  *ngIf="!restrictTabFlag"
                                        type="button" [disabled]="!boForm.valid || disabledOnclick">
                                        <span>
                                            <i class="fa fa-save"></i>&nbsp;Update </span>
                                    </button>
                               
                            
                        </div>
                    </form>
               
        

</section>

<app-alert></app-alert>